import { HTTP } from '@/axios_api/http-common'

const state = {
    currencies: []
}

interface IState {
    currencies: any[]
}

const getters = {
    getAllCurrencies(state:IState) {
        return state.currencies;
    }
}

const mutations = {
    saveCurrency(state: IState, payload: any) {
        state.currencies.push(payload);
    },
    setCurrencies(state: IState, budgetLines: any[]) {
        state.currencies = budgetLines
    },
    updateCurrencyMutation(state: IState, currency: any) {
        var indexToUpdate: number | null = 0
        state.currencies.forEach((currency: any, index: any) => {
            if (currency.id === currency.id) {
                indexToUpdate = index
            }
        })
        state.currencies.splice(indexToUpdate, 1, currency)
    },
    deleteCurrency(state: IState, id: number){
        for (let index = 0; index < state.currencies.length; index++) {
            if(state.currencies[index].id == id) {
                state.currencies.splice(index,1)
                break;
            }
       }
    },
}

const actions = {
    createCurrency ({commit}: {commit: any}, payload: any) {
        return new Promise((resolve, reject) => {
            HTTP.post('currency/create/', payload)
                .then((response: any) => {
                    commit('saveCurrency', response.data.data)
                    resolve(response)
                })
                .catch((error: any) => {
                    reject(error)
                })
        })
    },
    fetchCurrencies({commit}: {commit:any}) {
        return new Promise((resolve, reject) => {
            HTTP.get('currency').then((response: any) => {
                commit('setCurrencies', response.data.data)
                resolve(response)
            }).catch((err: any) => {
                reject(err)
            })
        })
    },
    updateCurrency({commit}: {commit: any}, payload: any) {
        return new Promise((resolve, reject) => {
            HTTP.put('currency/update/' + payload.id, {lineItem: payload.lineItem}).then((response: any) => {
                commit('updateCurrencyMutation', payload)
                resolve(response)
            }).catch((error: any) => {
                reject(error)
            })
        })
    },
    deleteCurrency({commit}: {commit: any}, payload: any) {
        return new Promise((resolve, reject) => {
            HTTP.delete('currency/delete/'+payload.id).then((response: any) => {
                commit('deleteCurrency', payload.id)
                resolve(response)
            }).catch((error: any) => {
                reject(error)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

